import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class RelatedContentApiService {
  constructor(
    protected Api: ApiService,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public listWithPageEvent(
    role: string,
    listingId?: string,
    filter?: {},
    PageEvent?: PageEvent
  ) {
    let endpoint = `${role}/listings/${listingId}/related-content?isAdmin=true`;

    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.getWithPageEventFilter(
      endpoint,
      PageEvent,
      filter,
      url
    ).then((ResponseBody: IResponseBody) => ResponseBody);
  }

  public save(role: string, RelatedContent, listingId) {
    return this.create(role, RelatedContent, listingId);
  }

  private create(role: string, RelatedContent, listingId) {
    const endpoint = `${role}/listings/${listingId}/related-content/${RelatedContent.related_listing_id}`;

    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.post(endpoint, RelatedContent, url)
      .then((id) => {
        this.Api.handleSuccess('Related content saved');
        return id;
      })
      .catch((error) => this.Api.handleError(error));
  }

  public delete(role: string, RelatedContent, listingId) {
    const endpoint = `${role}/listings/${listingId}/related-content/${RelatedContent.id}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url)
      .then(() => this.Api.handleSuccess('Related content deleted'))
      .catch((error) => this.Api.handleError(error));
  }
}
